import { API } from "aws-amplify";
import { apiGateway } from "../../config";
import { store } from "../";
import {
  FETCHING_ADMIN_ACCOUNTS,
  FETCHED_ADMIN_ACCOUNTS,
  FETCHING_ADMIN_SUBSCRIPTIONS,
  FETCHED_ADMIN_SUBSCRIPTIONS,
  FETCHING_ADMIN_USERS,
  FETCHED_ADMIN_USERS,
  FETCHING_ADMIN_PROJECTS,
  FETCHED_ADMIN_PROJECTS,
  FETCHING_ADMIN_COSTS,
  FETCHED_ADMIN_COSTS,
  FETCHING_ADMIN_DOCUMENTS,
  FETCHED_ADMIN_DOCUMENTS,
  FETCHING_ADMIN_SETTINGS,
  FETCHED_ADMIN_SETTINGS,
  FETCHING_ADMIN_PROMPTS,
  FETCHED_ADMIN_PROMPTS,
  FETCHING_ADMIN_BLOCKS,
  FETCHED_ADMIN_BLOCKS,
  FETCHING_ADMIN_PARTNER_INVITES,
  FETCHED_ADMIN_PARTNER_INVITES,
  SET_SETTINGS
} from "./constants";
const Gateway = apiGateway.find((gateway) => gateway.name === "admin");
const ClientGateway = apiGateway.find((gateway) => gateway.name === "client");
// Links endpoints are served by the client API service.
// Use a stable gateway name fallback to avoid accidental routing to /admin.
const LinksGatewayName = ClientGateway?.name || "client";

export const adminGetBlocks = (override) => async (dispatch) => {
  if ((!store.getState().admin.fetching_blocks && !store.getState().admin.fetched_blocks) || override) {
    dispatch({ type: FETCHING_ADMIN_BLOCKS, payload: true });
    return API.get(Gateway.name, `/get-blocks/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_BLOCKS, payload: false });
        dispatch({ type: FETCHED_ADMIN_BLOCKS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_BLOCKS, payload: false });
        dispatch({ type: FETCHED_ADMIN_BLOCKS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetPartnerInvites = (override) => async (dispatch) => {
  if ((!store.getState().admin.fetching_partner_invites && !store.getState().admin.fetched_partner_invites) || override) {
    dispatch({ type: FETCHING_ADMIN_PARTNER_INVITES, payload: true });
    return API.get(Gateway.name, `/get-partner-invites/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_PARTNER_INVITES, payload: false });
        dispatch({ type: FETCHED_ADMIN_PARTNER_INVITES, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_PARTNER_INVITES, payload: false });
        dispatch({ type: FETCHED_ADMIN_PARTNER_INVITES, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetPrompts = (override) => async (dispatch) => {
  if ((!store.getState().admin.fetching_prompts && !store.getState().admin.fetched_prompts) || override) {
    dispatch({ type: FETCHING_ADMIN_PROMPTS, payload: true });
    return API.get(Gateway.name, `/get-prompts/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_PROMPTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_PROMPTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_PROMPTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_PROMPTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetSettings = (override) => async (dispatch) => {
  if ((!store.getState().admin.fetching_settings && !store.getState().admin.fetched_settings) || override) {
    dispatch({ type: FETCHING_ADMIN_SETTINGS, payload: true });
    return API.get(Gateway.name, `/get-settings/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_SETTINGS, payload: false });
        dispatch({ type: FETCHED_ADMIN_SETTINGS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_SETTINGS, payload: false });
        dispatch({ type: FETCHED_ADMIN_SETTINGS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllAccounts = (override, options = {}) => async (dispatch) => {
  if ((!store.getState().admin.fetching_accounts && !store.getState().admin.fetched_accounts) || override) {
    dispatch({ type: FETCHING_ADMIN_ACCOUNTS, payload: true });
    const { limit = 200, offset = 0 } = options;
    return API.get(Gateway.name, `/get-accounts/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}?limit=${limit}&offset=${offset}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_ACCOUNTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_ACCOUNTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_ACCOUNTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_ACCOUNTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllSubscriptions = (override) => async (dispatch) => {
  if ((!store.getState().admin.fetching_subscriptions && !store.getState().admin.fetched_subscriptions) || override) {
    dispatch({ type: FETCHING_ADMIN_SUBSCRIPTIONS, payload: true });
    return API.get(Gateway.name, `/get-subscriptions/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_SUBSCRIPTIONS, payload: false });
        dispatch({ type: FETCHED_ADMIN_SUBSCRIPTIONS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_SUBSCRIPTIONS, payload: false });
        dispatch({ type: FETCHED_ADMIN_SUBSCRIPTIONS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllUsers = (override, options = {}) => async (dispatch) => {
  if ((!store.getState().admin.fetching_users && !store.getState().admin.fetched_users) || override) {
    dispatch({ type: FETCHING_ADMIN_USERS, payload: true });
      const { limit, offset, search, admin_only } = options || {};
      const parts = [];
      if (limit != null) parts.push(`limit=${encodeURIComponent(limit)}`);
      if (offset != null) parts.push(`offset=${encodeURIComponent(offset)}`);
      if (search) parts.push(`search=${encodeURIComponent(search)}`);
      if (admin_only) parts.push(`admin_only=true`);
      const qs = parts.length ? `?${parts.join('&')}` : '';
    return API.get(Gateway.name, `/get-users/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}${qs}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_USERS, payload: false });
        dispatch({ type: FETCHED_ADMIN_USERS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_USERS, payload: false });
        dispatch({ type: FETCHED_ADMIN_USERS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllProjects = (override, options = {}) => async (dispatch) => {
  if ((!store.getState().admin.fetching_projects && !store.getState().admin.fetched_projects) || override) {
    dispatch({ type: FETCHING_ADMIN_PROJECTS, payload: true });
    const { limit = 200, offset = 0 } = options;
    return API.get(Gateway.name, `/get-projects/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}?limit=${limit}&offset=${offset}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_PROJECTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_PROJECTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_PROJECTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_PROJECTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllCosts = (override, options = {}) => async (dispatch) => {
  if ((!store.getState().admin.fetching_costs && !store.getState().admin.fetched_costs) || override) {
    dispatch({ type: FETCHING_ADMIN_COSTS, payload: true });
    const { limit, offset, type, query_source, conversation_id } = options;
    const qs = [];
    if (limit != null) qs.push(`limit=${limit}`);
    if (offset != null) qs.push(`offset=${offset}`);
    if (type) qs.push(`type=${encodeURIComponent(type)}`);
    if (query_source) qs.push(`query_source=${encodeURIComponent(query_source)}`);
    if (conversation_id) qs.push(`conversation_id=${encodeURIComponent(conversation_id)}`);
    const query = qs.length ? `?${qs.join("&")}` : "";
    return API.get(Gateway.name, `/get-costs/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}${query}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_COSTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_COSTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_COSTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_COSTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminGetAllDocuments = (override, options = {}) => async (dispatch) => {
  if ((!store.getState().admin.fetching_documents && !store.getState().admin.fetched_documents) || override) {
    dispatch({ type: FETCHING_ADMIN_DOCUMENTS, payload: true });
    const { limit, offset, account_id, project_id, static: staticFilter, global_static } = options;
    const qs = [];
    if (limit != null) qs.push(`limit=${limit}`);
    if (offset != null) qs.push(`offset=${offset}`);
    if (account_id) qs.push(`account_id=${account_id}`);
    if (project_id) qs.push(`project_id=${project_id}`);
    if (staticFilter !== null && staticFilter !== undefined) qs.push(`static=${staticFilter}`);
    if (global_static) qs.push(`global_static=${global_static}`);
    const query = qs.length ? `?${qs.join("&")}` : "";
    return API.get(Gateway.name, `/get-documents/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}${query}`,
      {
        headers: {
          Authorization: store.getState().session.token
        }
      })
      .then((data) => {
        dispatch({ type: FETCHING_ADMIN_DOCUMENTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_DOCUMENTS, payload: true });
        return data;
      })
      .catch((error) => {
        dispatch({ type: FETCHING_ADMIN_DOCUMENTS, payload: false });
        dispatch({ type: FETCHED_ADMIN_DOCUMENTS, payload: true });
        return {
          success: false,
          message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
        };
      });
  }
};

export const adminUpdateSettings = (updates) => async (dispatch) => {
  return API.patch(Gateway.name, `/update-settings/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        updates
      }
    })
    .then((data) => {
      // Update session settings immediately so maintenance mode changes are reflected instantly
      // This prevents stale state if user navigates/refreshes before Ably message arrives
      if (data.success && data.payload) {
        dispatch({ type: SET_SETTINGS, payload: data.payload });
      }
      return data;
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
      };
    });
};

// Blocks update (single)
export const adminUpdateBlock = (blockId, updates) => async () => {
  if (!blockId || !updates || Object.keys(updates).length === 0) return { success:false, message:'no updates' };
  return API.patch(Gateway.name, `/update-block/${blockId}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { updates }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Users update (admin)
export const adminUpdateUser = async (userId, updates) => {
  if (!userId || !updates || Object.keys(updates).length === 0) return { success:false, message:'no updates' };
  return API.patch(Gateway.name, `/update-user/${userId}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: { updates }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Blocks batch update
export const adminUpdateBlocks = (blocksUpdates) => async (dispatch) => {
  if (!blocksUpdates || Object.keys(blocksUpdates).length === 0) return { success:false, message:'no updates' };
  const results = {};
  for (const id of Object.keys(blocksUpdates)) {
    // eslint-disable-next-line no-await-in-loop
    results[id] = await dispatch(adminUpdateBlock(id, blocksUpdates[id]));
  }
  return { success:true, results };
};

// Create block (admin)
export const adminCreateBlock = (data) => async () => {
  if (!data || !data.survey_id) return { success:false, message:'survey_id required' };
  return API.post(Gateway.name, `/create-block/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body: data
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Delete block (soft)
export const adminDeleteBlock = (blockId) => async () => {
  if (!blockId) return { success:false, message:'blockId required' };
  return API.del(Gateway.name, `/delete-block/${blockId}/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Clear Fasten connections (bulk reset ephemeral fields)
export const adminClearFastenConnections = async () => {
  return API.del(Gateway.name, `/clear-fasten-connections/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Short Links (no cached flags yet, simple pass-through helpers)
export const adminGetProjectLinks = async (projectId) => {
  if (!projectId) return { success: false, message: 'projectId required' };
  return API.get(LinksGatewayName, `/links/get-project-links/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}/${projectId}`, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminCreateShortLink = async ({ project_id, target_type, target_id, url, expires_in, max_uses, share_cognito, message, duration_label }) => {
  if (!project_id) return { success:false, message:'project_id required' };
  if (target_type === 'document' && !target_id) return { success:false, message:'target_id required for document' };
  if (target_type === 'url' && !url) return { success:false, message:'url required for url target' };
  const body = { project_id, target_type };
  if (target_type === 'document') body.target_id = target_id;
  if (target_type === 'url') body.url = url;
  if (expires_in) body.expires_in = expires_in; // seconds
  if (max_uses) body.max_uses = max_uses;
  if (share_cognito) body.share_cognito = share_cognito;
  if (message) body.message = message;
  if (duration_label) body.duration_label = duration_label;
  return API.post(LinksGatewayName, `/links/create/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token },
    body
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminRevokeShortLink = async (code, projectId) => {
  if (!code) return { success: false, message: 'code required' };
  return API.del(LinksGatewayName, `/links/revoke/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}/${code}`, {
    headers: { Authorization: store.getState().session.token }
  }).then(res => ({ ...res, projectId })).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminGetAllLinks = async () => {
  return API.get(LinksGatewayName, `/links/get-all/${(store.getState().session.account.account_id)}/${store.getState().authentication.user.cognito_id}`, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminGetAllLinksGlobal = async ({ limit = 500, next, status = 'all', type = 'all', search = '' } = {}) => {
  const qs = [];
  if (limit) qs.push(`limit=${limit}`);
  if (next) qs.push(`lek=${encodeURIComponent(next)}`);
  if (status && status !== 'all') qs.push(`status=${encodeURIComponent(status)}`);
  if (type && type !== 'all') qs.push(`type=${encodeURIComponent(type)}`);
  if (search) qs.push(`search=${encodeURIComponent(search)}`);
  const path = `/links/get-all-global/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}${qs.length ? `?${qs.join('&')}` : ''}`;
  return API.get(LinksGatewayName, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success:false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// Prompt Analytics
export const adminGetPromptAnalytics = async (days = 30) => {
  const path = `/get-prompt-analytics/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}?days=${days}`;
  return API.get(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

// AI Rule Optimization
export const adminGenerateRuleProposal = async (category = 'knowledgebase', context = '') => {
  const path = `/generate-rule-proposal/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`;
  return API.post(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token },
    body: { category, context }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminGetRuleProposals = async (category = 'all', source = null, status = 'pending', limit = 20, offset = 0) => {
  let path = `/get-rule-proposals/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}?category=${category}&status=${status}&limit=${limit}&offset=${offset}`;
  if (source) {
    path += `&source=${source}`;
  }
  return API.get(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminGetRuleProposalDetail = async (proposalId) => {
  const path = `/get-rule-proposal-detail/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${proposalId}`;
  return API.get(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminSubmitRuleChange = async (body) => {
  const path = `/submit-rule-change/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`;
  return API.post(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token },
    body
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminReviewRuleProposal = async (proposalId, action, editedChanges = null, notes = '') => {
  const path = `/review-rule-proposal/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${proposalId}`;
  return API.post(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token },
    body: { action, editedChanges, notes }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminRollbackRuleProposal = async (proposalId, notes = '') => {
  const path = `/rollback-rule-proposal/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${proposalId}`;
  return API.post(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token },
    body: { notes }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminDeleteRuleProposal = async (proposalId) => {
  const path = `/delete-rule-proposal/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${proposalId}`;
  return API.del(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminGetAuditLogs = async (filters = {}) => {
  const { table_name = 'all', operation = 'all', limit = 100, offset = 0 } = filters;
  const queryParams = `?table_name=${table_name}&operation=${operation}&limit=${limit}&offset=${offset}`;
  const path = `/audit-logs/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}${queryParams}`;
  return API.get(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminCleanupAuditLogs = async () => {
  const path = `/cron/cleanup-audit-logs`;
  return API.get(Gateway.name, path, {
    headers: { Authorization: store.getState().session.token }
  }).catch(error => ({ success: false, message: error.response && error.response.data ? error.response.data.message : 'Something went wrong.' }));
};

export const adminCreateDocument = (file) => async (dispatch) => {
  return API.post(
    Gateway.name,
    `/create-document/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        file
      }
    }
  )
  .then((data) => {
    return data;
  })
  .catch((error) => {
    return {
      success: false,
      error
    };
  });
};

export const adminUpdateDocument = (documentId, updates, newFile = null) => async (dispatch) => {
  return API.patch(
    Gateway.name,
    `/update-document/${documentId}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: {
        updates,
        new_file: newFile
      }
    }
  )
  .then((data) => {
    return data;
  })
  .catch((error) => {
    return {
      success: false,
      error
    };
  });
};

export const adminDeleteDocument = (documentId) => async (dispatch) => {
  return API.del(
    Gateway.name,
    `/delete-document/${documentId}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    }
  )
  .then((data) => {
    return data;
  })
  .catch((error) => {
    return {
      success: false,
      error
    };
  });
};

// Benefits Management (plain async - no Redux state needed)
export const adminGetBenefits = async (options = {}) => {
  const { state, search, limit = 100, offset = 0 } = options;
  const qs = [];
  if (state) qs.push(`state=${encodeURIComponent(state)}`);
  if (search) qs.push(`search=${encodeURIComponent(search)}`);
  if (limit != null) qs.push(`limit=${limit}`);
  if (offset != null) qs.push(`offset=${offset}`);
  const query = qs.length ? `?${qs.join("&")}` : "";
  
  return API.get(
    Gateway.name,
    `/get-benefits/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}${query}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    }
  )
  .then((data) => data)
  .catch((error) => ({
    success: false,
    message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
  }));
};

export const adminCreateBenefit = async (benefitData) => {
  return API.post(
    Gateway.name,
    `/create-benefit/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: benefitData
    }
  )
  .then((data) => data)
  .catch((error) => ({
    success: false,
    message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
  }));
};

export const adminUpdateBenefit = async (benefitId, updates) => {
  return API.put(
    Gateway.name,
    `/update-benefit/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${benefitId}`,
    {
      headers: {
        Authorization: store.getState().session.token
      },
      body: { updates }
    }
  )
  .then((data) => data)
  .catch((error) => ({
    success: false,
    message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
  }));
};

export const adminDeleteBenefit = async (benefitId) => {
  return API.del(
    Gateway.name,
    `/delete-benefit/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}/${benefitId}`,
    {
      headers: {
        Authorization: store.getState().session.token
      }
    }
  )
  .then((data) => data)
  .catch((error) => ({
    success: false,
    message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
  }));
};

// Diagnoses Catalog / Requests (plain async — no Redux state needed)
//
// These hit the admin API and power the DiagnosesTab. See
// backend/api/client/data/diagnoses.js for the server-side contract and
// docs/ORCHESTRATOR_TEST_PROTOCOL.md for the approval cascade semantics.

const diagnosesAuth = () => ({
  headers: { Authorization: store.getState().session.token }
});
const diagnosesPath = (route) =>
  `${route}/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`;

export const adminGetDiagnosesCatalog = async ({ status = "all" } = {}) => {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  return API.get(
    Gateway.name,
    `${diagnosesPath("/get-diagnoses-catalog")}${qs}`,
    diagnosesAuth()
  )
    .then((data) => data)
    .catch((error) => ({
      success: false,
      message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
    }));
};

export const adminUpdateDiagnosesCatalog = async (payload) => {
  return API.post(
    Gateway.name,
    diagnosesPath("/update-diagnoses-catalog"),
    { ...diagnosesAuth(), body: payload }
  )
    .then((data) => data)
    .catch((error) => ({
      success: false,
      message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
    }));
};

export const adminGetDiagnosesRequests = async ({ status = "all" } = {}) => {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  return API.get(
    Gateway.name,
    `${diagnosesPath("/get-diagnoses-requests")}${qs}`,
    diagnosesAuth()
  )
    .then((data) => data)
    .catch((error) => ({
      success: false,
      message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
    }));
};

export const adminResolveDiagnosesRequest = async (requestId, body) => {
  return API.post(
    Gateway.name,
    `/resolve-diagnoses-request/${requestId}/${store.getState().session.account.account_id}/${store.getState().authentication.user.cognito_id}`,
    { ...diagnosesAuth(), body }
  )
    .then((data) => data)
    .catch((error) => ({
      success: false,
      message: error.response && error.response.data ? error.response.data.message : "Something went wrong."
    }));
};
